import React, { useState } from "react";
import "./Login.css";
import LoginLogo from "../../Components/Assets/images/logo2.png";
import { Link, useNavigate } from "react-router-dom";
import { account, tablesDB, DB_ID, USERS_TABLE } from "../../appwrite";
import { useTitle } from "../../hooks/useTitle";
import { Eye, EyeOff } from "lucide-react";

function Login() {
  useTitle("Seller Dashboard");
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");

    try {
      await account.createEmailPasswordSession(email, password);
      const user = await account.get();

      const userDoc = await tablesDB.getRow({
        databaseId: DB_ID,
        tableId: USERS_TABLE,
        rowId: user.$id,
      });

      if (userDoc.userRole !== "seller") {
        await account.deleteSession("current");
        setError("ACCESS DENIED! Only sellers can log in here.");
        return;
      }

      if (!userDoc.isVerified) {
        navigate("/verify-email");
        return;
      }

      navigate("/");
    } catch (err) {
      try {
        await account.deleteSession("current");
      } catch {}
      setError("Email or password is incorrect.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-page">
      <div className="auth-card">
        <a href="/">
          <img className="auth-logo" src={LoginLogo} alt="TrendBay" />
        </a>
        <div className="auth-badge">🏪 Seller Portal</div>
        <h1 className="auth-heading">Seller Sign In</h1>
        <p className="auth-sub">Access your TrendBay seller dashboard</p>

        {error && <div className="auth-error">{error}</div>}

        <form onSubmit={handleLogin}>
          <div className="auth-field">
            <label className="auth-label">Email address</label>
            <input
              className="auth-input"
              type="email"
              placeholder="you@example.com"
              value={email}
              onChange={(e) => {
                setEmail(e.target.value);
                setError("");
              }}
              disabled={loading}
              required
            />
          </div>
          <div className="auth-field">
            <label className="auth-label">Password</label>
            <div className="auth-pw-wrap">
              <input
                className="auth-input"
                type={showPassword ? "text" : "password"}
                placeholder="Enter your password"
                value={password}
                onChange={(e) => {
                  setPassword(e.target.value);
                  setError("");
                }}
                disabled={loading}
                required
              />
              <span
                className="auth-pw-toggle"
                onClick={() => setShowPassword((p) => !p)}
              >
                {showPassword ? <EyeOff size={18} /> : <Eye size={18} />}
              </span>
            </div>
          </div>
          <Link to="/reset-password" className="auth-forgot" style={{ display: "block", marginBottom: 12 }}>
            Forgot password?
          </Link>
          <button type="submit" className="auth-btn-primary" disabled={loading}>
            {loading ? "Signing in…" : "Sign In"}
          </button>
        </form>

        <p className="auth-footer-text" style={{ marginTop: "16px" }}>
          Don't have a seller account? <Link to="/signup">Create one here</Link>
        </p>
        <p className="auth-footer-text">
          <a href="https://mart.trendbayds.com">← Back to TrendBay Mart</a>
        </p>
      </div>
    </div>
  );
}

export default Login;
